// extracted by mini-css-extract-plugin
export default {"items":"ReportOrderConfigurationView__items--TOM4KkuN3nArrPKKVV22"};